/* This file is only used in V2 */

export const STORAGE_CITY_V2 = '__CITY_V2__';
export const STORAGE_SENDER = '__SENDER__';
export const STORAGE_PICKUP_POIS = '__PICKUP_POIS__';
export const STORAGE_META_DATA_VERSION = '__META_DATA_VERSION__';
export const STORAGE_BUR_GROUPING_DEFAULT_ON = '__BUR_GROUPING_DEFAULT_ON__';
export const STORAGE_BUR_GROUPING_NOT_SHOW_POPUP =
  '__BUR_GROUPING_NOT_SHOW_POPUP__';

export default {};
